import React, { useState } from 'react';
import { HiOutlineMail } from "react-icons/hi";
import { BsTelephone } from "react-icons/bs";
import { IoLocationOutline } from "react-icons/io5";
import './TopHeader.css';

const TopHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="top-header">
      <div className="header-content">
        <div className="address">
          <span className="location">
             <IoLocationOutline  className="icon" />Sahar Sahi, WN 08, Infront of Baripada ITI, Baripad, Mayaurbhanj,  Odisha-757001 </span>
        </div>
        <div className="contact-info">
          <span className="phone">
            <BsTelephone className="icon" />
            +91 7978523365
          </span>
          <span className="email">
            <HiOutlineMail className="icon" />
         < a href="mailto:ssvnbaripada@gmail.com"  style={{color:"white"}}>ssvnbaripada@gmail.com</a>
          </span>
        </div>
        {/* <div className="hamburger-menu" onClick={() => setMenuOpen(!menuOpen)}>
          <FaBars />
        </div> */}
      </div>
      {menuOpen && (
        <div className="mobile-menu">
          {/* Add your mobile menu items here */}
        </div>
      )}
    </header>
  );
};

export default TopHeader;